module.exports = __webpack_public_path__ + "img/schedule-visit-en.35e0d5e.png";